import { useClientQuery } from "@graphql/clients/clients.g";

import { Box } from "@design-system/Box/Box";
import { ValueComponentProps } from "@design-system/Select/Select";
import { Text } from "@design-system/Text/Text";

type Props = ValueComponentProps;

/**
 * Handles the display of client ID values in a select component.
 */
export const SelectClientValue = ({ value }: Props) => {
  const clientQuery = useClientQuery({ clientId: value });

  const client = clientQuery.data?.client;

  return (
    <Box gap={6} align="center">
      <Text>{client?.name}</Text>
    </Box>
  );
};
